import React from 'react';
import { useNavigate } from 'react-router-dom';

import useAuthStore from 'src/hooks/auth/useAuthStore';

import config from 'src/shared/config';

import { Box } from 'fasoo-ui-component-next';
import HeaderStatusBar from '../HeaderStatusBar';
import classNames from 'classnames';
import AppBarBiIcon from 'src/components/fxm/logo/users/AppBarBiIcon';

import './AppBar.scss';

const AppBar: React.FC = () => {
  const { authEntity, startSignOut } = useAuthStore();
  const navigate = useNavigate();

  // if (!authEntity) {
  //   return null;
  // }
  const handleClickSignOut = (): void => {
    startSignOut();
  };

  // console.log(import.meta.env.VITE_APP_TYPE);
  return (
    <div className={classNames('layout-head-root')}>
      <Box classes={'header-root-logo'}>
        <Box alignItems={'center'}>
          <span
            className="logo"
            onClick={() => {
              if (authEntity) {
                navigate(config.url('/approval/pending'));
              } else {
                navigate(config.url('/main'));
              }
            }}
          >
            <AppBarBiIcon />
          </span>
        </Box>
      </Box>
      <Box classes={'header-root-statusbar'} alignItems={'center'}>
        <HeaderStatusBar
          // handleMenuToService={() => console.log('handleMenuToService')}
          // moveToAdminSite={() => console.log('moveToAdminSite')}
          handleLogOut={handleClickSignOut}
          authEntity={authEntity}
          memberInfo={undefined}
        />
      </Box>
    </div>
  );
};

export default AppBar;
